<template>
  <portal to="modal">
    <v-dialog
      v-model="showModal"
      persistent
      max-width="500px"
      class="ma-5"
    >
      <v-card
        class="py-5 px-2"
      >
        <img v-if="companyImage"
          :src="companyImage"
          class="mb-4"
          height=50
        />
        <v-card-text>
          <div class="mb-4" v-if="$slots['main-text']">
            <slot name="main-text" />
          </div>
          <div class="mb-4" v-if="$slots['secondary-text']">
            <slot name="secondary-text"/>
          </div>
          <div class="mb-2" v-if="$slots['tertiary-text']">
            <slot name="tertiary-text"/>
          </div>
        </v-card-text>
        <v-card-actions
          class="wf-justify-content-center"
        >
          <v-layout row wrap>
            <v-flex v-if="$slots['main-button'] || mainButtonFunction" xs12>
              <slot name="main-button" v-if="$slots['main-button']" />
              <v-btn
                v-else
                class="mb-3 subheading heavy modal-button"
                color="secondary" large
                @click.stop="mainButtonFunction()"
              >
                <slot name="main-button-text"/>
              </v-btn>
            </v-flex>
            <div class="pa-2" v-if="$slots['warning-text']">
              <v-alert color="warning" icon="warning" :value="$slots['warning-text']">
                <slot name="warning-text"/>
              </v-alert>
            </div>
            <v-flex xs12
              v-if="secondaryButtonFunction"
            >
              <v-btn
                class="modal-button"
                color="secondary" flat
                @click.stop="secondaryButtonFunction()"
              >
                <slot name="secondary-button-text"/>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </portal>
</template>

<script>
  export default {
    name: 'StatusModal',
    props: {
      companyImage: {
        type: String,
        default: ''
      },
      mainButtonFunction: {
        type: Function,
        default: null
        // default: () => {}
      },
      secondaryButtonFunction: {
        type: Function,
        default: null
      },
      showModal: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
  .modal-button {
    width: 80%;
    max-width: 200px;
  }

  .heavy {
    font-weight: 600;
  }
</style>
